import ErrorMessage from 'framework-asset-preview-lib/internal/shared/components/ErrorMessage';
import LoadingOverlay from 'framework-asset-preview-lib/internal/shared/components/LoadingOverlay';
import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
import useFetchAssetPerformance from '../hooks/useFetchAssetPerformance';
import PerformanceGroupSection from './PerformanceGroupSection';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasMetrics } from '../utils/performanceConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PerformanceSection({
  crmObject,
  nonCrmObject,
  properties,
  propertyGroups,
  campaignObjectId
}) {
  const {
    data,
    error,
    loading
  } = useFetchAssetPerformance({
    crmObject,
    nonCrmObject,
    campaignObjectId
  });
  const {
    error: dataProviderError
  } = usePreviewData();
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      previewType: "sidepanel"
    });
  }
  if (dataProviderError.customError) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      errorType: dataProviderError.customError.errorType,
      objectId: crmObject.objectId,
      objectType: crmObject.objectTypeId,
      customError: dataProviderError.customError
    });
  }
  if (error || !data) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      errorType: "PERFORMANCE_TAB",
      objectId: crmObject.objectId,
      objectType: crmObject.objectTypeId
    });
  }
  if (!hasMetrics(data)) {
    return /*#__PURE__*/_jsx(View, {
      as: "section",
      paddingInline: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.tabs.performance.noResults"
      })
    });
  }
  return /*#__PURE__*/_jsx("section", {
    children: data.map((performanceGroup, index) => /*#__PURE__*/_jsx(PerformanceGroupSection, {
      crmObject: crmObject,
      nonCrmObject: nonCrmObject,
      performanceGroup: performanceGroup,
      properties: properties,
      propertyGroups: propertyGroups
    }, index))
  });
}